import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LabelEditorShellComponent } from './containers/label-editor-shell/label-editor-shell.component';

@NgModule({
  declarations: [
    LabelEditorShellComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    LabelEditorShellComponent,
    CommonModule
  ]
})
export class LabelEditorModule {
  constructor() {}
}
